import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";

import HeaderBox from "../../reuseableComponents/headerBox/HeaderBox";
import {
  GET_ALL_IPS_DEFICIENCIES,
  GET_DEF_CODES,
  GET_ACTIVE_IPS_DEFICIENCIES
} from "../../../queries/archiveQrys/secureQrys/ipsDeficiencyQrys";
import IpsDeficiencyTable from "./IpsDeficiencyTable";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorMessage from "../../reuseableComponents/ErrorHandler";
import ModalWindow from "../../reuseableComponents/ModalWindow";
import IpsDeficiencyForm from "./IpsDeficiencyForm";

const IpsDeficiencyAdminPage = () => {
  const [show, setShow] = useState(false);
  const [item, setItem] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  const [modalId, setModalId] = useState(null);
  const { data: tableData, loading, error } = useQuery(GET_ALL_IPS_DEFICIENCIES);
  //TODO: if defCodesLoading?? If defCodesError?
  const { data: defCodes, loading: defCodesLoading, error: defCodesError } = useQuery(GET_DEF_CODES);
  const {
    data: activeList,
    loading: activeListLoading,
    error: activeListError
  } = useQuery(GET_ACTIVE_IPS_DEFICIENCIES);

  const handleClose = () => {
    setShow(false);
    setItem(null);
  };

  const handleShow = (id) => {
    setSubmitSuccess(null);
    setSubmitError(null);
    setShow(id);
    setModalId(id);
  };

  const setItemObj = (value) => {
    setItem(value);
  };

  if (loading || error || defCodesLoading || activeListLoading || defCodesError || activeListError) {
    return (
      <div className='page-container ips-deficiency-admin-container'>
        <Row>
          <Col>
            <Link className='m-2 hyperlink' to='/' cypressid='home-page'>
              Home
            </Link>
            <span className='m-2'> | </span>
            <Link className='m-2 hyperlink' to='/secure/module-index' cyressid='module-index'>
              Modules
            </Link>
            <span className='m-2 hyperlink'> | </span>
            <Link className='m-2 hyperlink' to='/secure/ips/ips-index' cyressid='ips-index'>
              IPS Menu
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='ipsDeficiencyPage'>
              <h3 style={{ color: "#fff" }}>IPS Deficiency Admin</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorMessage error={error} /> : ""}</Col>
        </Row>
      </div>
    );
  }

  return (
    <div className='page-container ips-deficiency-admin-container'>
      <Row>
        <Col>
          <Link className='m-2 hyperlink' to='/' cypressid='home-page'>
            Home
          </Link>
          <span className='m-2'> | </span>
          <Link className='m-2 hyperlink' to='/secure/module-index' cyressid='module-index'>
            Modules
          </Link>
          <span className='m-2'> | </span>
          <Link className='m-2 hyperlink' to='/secure/ips/ips-index' cyressid='ips-index'>
            IPS Menu
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='ipsDeficiencyPage'>
            <h3 style={{ color: "#fff" }}>IPS Deficiency Admin</h3>
          </HeaderBox>
        </Col>
      </Row>
      <ModalWindow
        successMsg={submitSuccess}
        errorMsg={submitError}
        setSubmitSuccess={setSubmitSuccess}
        setSubmitError={setSubmitError}
        show={show}
        id={modalId}
        handleClose={handleClose}
        modalTitle={modalId + " Deficiency"}
        component={IpsDeficiencyForm}
        defCodes={defCodes.getUnassignedIpsDeficiencies}
        item={item}
      />
      <Row>
        <Col>
          <IpsDeficiencyTable
            activeList={activeList.getActiveIpsDeficiencies}
            data={tableData.getIpsDeficiencies}
            handleShow={handleShow}
            setItem={setItemObj}
          />
        </Col>
      </Row>
    </div>
  );
};

export default IpsDeficiencyAdminPage;
